import { useSeo } from "../hooks/useSeo";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";

const Block = ({ id, title, children }) => (
  <Reveal>
    <div id={id} className="scroll-mt-28 py-8 border-b border-border/60 last:border-0">
      <h2 className="font-serif text-3xl md:text-4xl text-ink mb-5">{title}</h2>
      <div className="space-y-4 text-stone leading-relaxed max-w-3xl">{children}</div>
    </div>
  </Reveal>
);

export default function Privacy() {
  useSeo(
    "Privacy e Cookie Policy — Susanna Paoletti",
    "Informativa sulla privacy e cookie policy del sito di Susanna Paoletti, psicologa e psicoterapeuta a Macerata."
  );

  return (
    <>
      <PageHeader
        eyebrow="Informazioni legali"
        title="Privacy e Cookie Policy"
        subtitle="Informativa sul trattamento dei dati personali e sull'utilizzo dei cookie. I riferimenti contrassegnati come [dato da inserire] verranno completati con le informazioni ufficiali."
      />

      <section className="py-14 md:py-20" data-testid="privacy-content">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Block id="titolare" title="Titolare del trattamento">
            <p>
              Titolare del trattamento dei dati è Susanna Paoletti, con studio a Macerata (Marche).
              Recapiti del titolare: <strong className="text-ink">[dato da inserire]</strong>.
            </p>
          </Block>

          <Block id="dati" title="Dati raccolti e finalità">
            <p>
              Attraverso il modulo di contatto vengono raccolti i dati che scegli di fornire: nome, email,
              eventuale numero di telefono e il contenuto del messaggio. Tali dati sono trattati esclusivamente
              per rispondere alla tua richiesta e per gli eventuali contatti conseguenti.
            </p>
            <p>
              Ti invitiamo a non inserire nel modulo informazioni sanitarie particolarmente sensibili. Il
              conferimento dei dati è facoltativo, ma necessario per poter dare seguito alla richiesta.
            </p>
          </Block>

          <Block id="base-giuridica" title="Base giuridica e conservazione">
            <p>
              Il trattamento si fonda sul consenso espresso al momento dell'invio del modulo. I dati sono
              conservati per il tempo necessario a gestire la richiesta e agli adempimenti connessi, e comunque
              secondo i termini indicati dal titolare: <strong className="text-ink">[dato da inserire]</strong>.
            </p>
          </Block>

          <Block id="diritti" title="I tuoi diritti">
            <p>
              In qualità di interessato puoi esercitare i diritti previsti dalla normativa applicabile (accesso,
              rettifica, cancellazione, limitazione, opposizione e portabilità) scrivendo ai recapiti del titolare.
              Hai inoltre diritto di proporre reclamo all'autorità di controllo competente.
            </p>
          </Block>

          <Block id="cookie" title="Cookie Policy">
            <p>
              Questo sito utilizza cookie tecnici necessari al suo corretto funzionamento, che non richiedono
              consenso. Eventuali cookie di analisi o di terze parti vengono attivati solo previo tuo consenso
              esplicito e non sono mai preselezionati.
            </p>
            <p>
              Puoi gestire le tue preferenze in qualsiasi momento tramite il pulsante
              <button
                onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))}
                className="text-sage-dark underline underline-offset-2 mx-1"
                data-testid="privacy-open-preferences"
              >
                "Gestione delle preferenze"
              </button>
              o dalle impostazioni del tuo browser.
            </p>
          </Block>

          <Block id="modifiche" title="Modifiche all'informativa">
            <p>
              La presente informativa può essere aggiornata nel tempo. Le eventuali modifiche saranno pubblicate
              in questa pagina. Ultimo aggiornamento: <strong className="text-ink">[dato da inserire]</strong>.
            </p>
          </Block>
        </div>
      </section>
    </>
  );
}
